import React, { useEffect, useRef } from 'react';

/**
 * Burst de petites particules émises depuis le centre, déclenchées à chaque
 * `trigger` (number qui incrémente). Très léger : pas de canvas, juste des spans
 * positionnés en absolu et animés via CSS keyframes.
 * - Respecte prefers-reduced-motion (pas d'animation)
 * - Discret : 12 particules colorées brand pendant ~700ms
 */
export function CelebrateBurst({ trigger = 0, color = 'hsl(var(--primary))' }) {
  const ref = useRef(null);
  const lastTrigger = useRef(0);

  useEffect(() => {
    if (trigger === 0 || trigger === lastTrigger.current) return;
    lastTrigger.current = trigger;
    if (typeof window === 'undefined') return;
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;
    const root = ref.current;
    if (!root) return;
    // nettoie
    root.innerHTML = '';
    const N = 12;
    for (let i = 0; i < N; i++) {
      const span = document.createElement('span');
      const angle = (i / N) * Math.PI * 2;
      const dist = 28 + Math.random() * 16;
      const dx = Math.cos(angle) * dist;
      const dy = Math.sin(angle) * dist;
      span.style.cssText = `
        position:absolute;
        left:50%; top:50%;
        width:6px; height:6px; border-radius:9999px;
        background:${color};
        transform:translate(-50%,-50%);
        opacity:0.95;
        animation: c2r-burst 720ms cubic-bezier(0.16,1,0.3,1) forwards;
        --dx: ${dx}px;
        --dy: ${dy}px;
        animation-delay: ${i * 12}ms;
        pointer-events:none;
      `;
      root.appendChild(span);
    }
    const t = setTimeout(() => { if (root) root.innerHTML = ''; }, 1100);
    return () => clearTimeout(t);
  }, [trigger, color]);

  return (
    <span
      ref={ref}
      aria-hidden="true"
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 1 }}
    />
  );
}
